import React from 'react';
import { Form, Select, InputNumber, Button, Space, Radio } from 'antd';
import { DisposalMethod, DisposalMethodOptions, LowPriceOptionOptions, toSelectOptions } from '../../../../constants/debtEnums';
import { amountFormatter, amountParser } from '../../../../utils/numberFormat';

const DisposalStep = ({ value, onChange, onNext, onPrev, config }) => {
  const [form] = Form.useForm();


  const handleValuesChange = (_, allValues) => {
    const pricing = allValues.transfer_pricing_amount;
    const discount = allValues.transfer_discount_rate;
    const lowOpt = allValues.low_price_option;
    const toNum = (v) => {
      const n = Number(amountParser(v ?? 0));
      return Number.isFinite(n) ? n : 0;
    };
    if (lowOpt !== undefined) {
      if (String(lowOpt) === 'PRICING') {
        form.setFieldsValue({ transfer_discount_rate: undefined });
        allValues.transfer_discount_rate = undefined;
      } else if (String(lowOpt) === 'DISCOUNT') {
        form.setFieldsValue({ transfer_pricing_amount: undefined });
        allValues.transfer_pricing_amount = undefined;
      } else if (String(lowOpt) === 'NEGOTIATED') {
        form.setFieldsValue({ transfer_pricing_amount: undefined, transfer_discount_rate: undefined });
        allValues.transfer_pricing_amount = undefined;
        allValues.transfer_discount_rate = undefined;
      }
    }
    onChange(prev => ({
      ...prev,
      ...allValues,
      transfer_pricing_amount: pricing !== undefined ? toNum(pricing) : prev.transfer_pricing_amount,
      transfer_discount_rate: discount !== undefined ? Number(discount) : prev.transfer_discount_rate,
      low_price_option: lowOpt !== undefined ? lowOpt : prev.low_price_option,
    }));
  };

  const handleNext = async () => {
    try {
      await form.validateFields();
      onNext();
    } catch (e) {}
  };

  const isLowPrice = value.disposal_method === DisposalMethod.LOW_PRICE_TRANSFER;
  const totalAmount = (() => {
    const p = Number(amountParser(value.principal_amount ?? 0)) || 0;
    const pe = Number(amountParser(value.penalty_amount ?? 0)) || 0;
    const o = Number(amountParser(value.other_amount ?? 0)) || 0;
    return p + pe + o;
  })();
  const limit = totalAmount * 0.30;

  return (
    <Form
      form={form}
      layout="vertical"
      initialValues={value}
      onValuesChange={handleValuesChange}
    >
      <Form.Item label="处置方式" name="disposal_method" rules={[{ required: true, message: '请选择处置方式' }]}> 
        <Select options={toSelectOptions(config?.disposal_method || DisposalMethodOptions)} placeholder="请选择" />
      </Form.Item>

      {isLowPrice && (
        <>
          <Form.Item label="低价转让方式" name="low_price_option" rules={[{ required: true, message: '请选择低价转让方式' }]}> 
            <Radio.Group buttonStyle="solid">
              {(config?.low_price_option || LowPriceOptionOptions).map(o => {
                const v = String(o.value ?? o.code);
                return <Radio.Button key={v} value={v}>{o.label}</Radio.Button>;
              })}
            </Radio.Group>
          </Form.Item>
          {value.low_price_option === 'PRICING' && (
            <Form.Item label="定价金额" name="transfer_pricing_amount" rules={[{ validator: (_, v) => {
              const num = Number(amountParser(v));
              if (!Number.isFinite(num)) return Promise.reject(new Error('请输入数字'));
              if (num < 0) return Promise.reject(new Error('不得小于0'));
              if (num > limit) return Promise.reject(new Error('不得超过总金额的30%'));
              return Promise.resolve();
            } }]}> 
              <InputNumber min={0} precision={0} step={1} style={{ width: 240 }} formatter={amountFormatter} parser={amountParser} />
            </Form.Item>
          )}
          {value.low_price_option === 'DISCOUNT' && (
            <Form.Item label="折扣比例(%)" name="transfer_discount_rate" rules={[{ validator: (_, v) => {
              const num = Number(v ?? 0);
              if (!Number.isFinite(num)) return Promise.reject(new Error('请输入数字'));
              if (num < 0 || num > 100) return Promise.reject(new Error('0-100之间'));
              if (num > 30) return Promise.reject(new Error('不得超过30%'));
              return Promise.resolve();
            } }]}> 
              <InputNumber min={0} max={100} precision={2} step={0.01} style={{ width: 240 }} />
            </Form.Item>
          )}
          {value.low_price_option === 'NEGOTIATED' && (
            <Form.Item label="另行商议">
              <span>由平台撮合后另行商议具体价格，无需填写定价或折扣。</span>
            </Form.Item>
          )}
        </>
      )}

      <Form.Item>
        <Space>
          <Button onClick={onPrev}>上一步</Button>
          <Button type="primary" onClick={handleNext}>下一步</Button>
        </Space>
      </Form.Item>
    </Form>
  );
};

export default DisposalStep;
